import { render, staticRenderFns } from "./authorityManagementedit.vue?vue&type=template&id=7b729198&scoped=true&"
import script from "./authorityManagementedit.vue?vue&type=script&lang=js&"
export * from "./authorityManagementedit.vue?vue&type=script&lang=js&"
import style0 from "./authorityManagementedit.vue?vue&type=style&index=0&id=7b729198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b729198",
  null
  
)

export default component.exports